import { ButtonLink } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const InlineButtonLink = styled(ButtonLink)`
  display: inline;
  ${({ theme }) => theme.typography['body-sm']}
`
